// Lightweight Divider component - replaces NextUI Divider
import React from 'react';

const Divider = ({ 
  orientation = 'horizontal',
  className = '',
  ...props 
}) => {
  if (orientation === 'vertical') {
    return (
      <div
        className={`w-px bg-gray-200 self-stretch ${className}`}
        {...props}
      />
    );
  }

  return (
    <div
      className={`h-px bg-gray-200 w-full ${className}`}
      {...props}
    />
  );
};

export default Divider;
